module.exports = __webpack_public_path__ + "img/logo.c530bae0.svg";